import { createFileRoute } from "@tanstack/react-router";

import { AdminDeletionsPage } from "@/components/AdminDeletionsPage";

// /admin/deletions — почему репетиторы удаляют анкеты (28.10.2026). noindex.
export const Route = createFileRoute("/admin_/deletions")({
  head: () => ({ meta: [{ title: "Удаления анкет — Yolutap" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: AdminDeletionsPage,
});
